export const buildTeamMembersLimitUsage = ({ memberLimitMax, seatsCount, seatsLeft, disabledNote }) => {
  const current = Math.max(seatsCount - seatsLeft, 0);

  if (memberLimitMax == null || memberLimitMax < 0) {
    return null;
  }

  if (memberLimitMax === 0) {
    return {
      label: "Team Members",
      current,
      max: 0,
      disabled: true,
      disabledNote,
    };
  }

  return { label: "Team Members", current, max: memberLimitMax, disabled: false };
};
